<template>
    <LayoutBase class="home">
        <div class="tcm-home">
            <div class="header">
                <img src="@/assets/tcm-portal/logo.png" />
            </div>
            <van-swipe ref="swipe" class="swipe-container" @change="onSwipeChange" :autoplay="3000">
                <van-swipe-item>
                    <div class="swipe-item welcome-img">
                        <img src="@/assets/tcm-portal/tcm-welcome.png" />
                        <div class="welcome-info">
                            <div class="title new-title">
                                <span class="main-title-1">{{ $t("cdutcm.home") }}</span>
                                <span class="main-title-2">{{ $t("cdutcm.school") }}</span>
                            </div>
                        </div>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="swipe-item about-us-img">
                        <img src="@/assets/tcm-portal/tcm-about-us.png" />
                        <div class="img-info">
                            <div class="title">
                                <span>{{ $t("cdutcm.aboutUs") }}</span>
                                <div class="divider"></div>
                            </div>
                            <div class="content">
                                <div class="info-text">{{ localCdutcmPortalConfig["aboutUsMessage"][0] }}</div>
                                <div class="info-text">{{ localCdutcmPortalConfig["aboutUsMessage"][1] }}</div>
                            </div>
                        </div>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="swipe-item resources-img">
                        <img src="@/assets/tcm-portal/tcm-resources.png" />
                        <div class="img-info">
                            <div class="title">
                                <span>{{ $t("cdutcm.introduction") }}</span>
                                <div class="divider"></div>
                            </div>
                            <div class="content">
                                <div class="info-text">{{ localCdutcmPortalConfig["teachingAchievements"][0] }}</div>
                                <div class="info-text">{{ localCdutcmPortalConfig["teachingAchievements"][1] }}</div>
                            </div>
                        </div>
                    </div>
                </van-swipe-item>
                <template #indicator>
                    <div class="custom-indicator">
                        <div
                            class="custom-indicator-item"
                            :class="{ active: swipeCurrentIndex === 0 }"
                            @click="selectSwipe(0)"
                        >
                            <img class="custom-indicator-item-img" src="@/assets/tcm-portal/front-page.svg" />
                            <div>{{ $t("cdutcm.frontPage") }}</div>
                        </div>
                        <div
                            class="custom-indicator-item"
                            :class="{ active: swipeCurrentIndex === 1 }"
                            @click="selectSwipe(1)"
                        >
                            <img class="custom-indicator-item-img" src="@/assets/tcm-portal/about-us.svg" />
                            <div>{{ $t("cdutcm.aboutUs") }}</div>
                        </div>
                        <div
                            class="custom-indicator-item"
                            :class="{ active: swipeCurrentIndex === 2 }"
                            @click="selectSwipe(2)"
                        >
                            <img class="custom-indicator-item-img" src="@/assets/tcm-portal/introduction.svg" />
                            <div>{{ $t("cdutcm.introduction") }}</div>
                        </div>
                    </div>
                </template>
            </van-swipe>
            <div class="body">
                <div class="welcome-title">
                    <div class="title">
                        <span class="main-title-1">{{ $t("cdutcm.search") }}</span>
                    </div>
                    <div class="search">
                        <input class="search-input" :placeholder="$t('cdutcm.pSearch')" v-model="keyWord" />
                        <button class="search-button" @click="$router.push(`/tcm/search?q=${keyWord}`)">
                            <img src="@/assets/tcm-portal/search.svg" />
                        </button>
                    </div>
                </div>
                <PlanCards></PlanCards>
                <PlanCards sort-key="hot"></PlanCards>
                <div class="comment">
                    <div class="title">
                        {{ $t("cdutcm.comment") }}
                    </div>
                    <van-swipe
                        class="comment-list"
                        ref="commentSwipe"
                        @change="onCommentSwipeChange"
                        :loop="false"
                        :show-indicators="false"
                    >
                        <van-swipe-item v-for="(item, index) in localCdutcmPortalConfig.commentInfo" :key="index">
                            <CommentCard :plan-item="item" :index="index"></CommentCard>
                        </van-swipe-item>
                        <template #indicator>
                            <div
                                class="circle-container left-circle-container"
                                @click="commentSwipePrev"
                                v-show="commentSwipeCurrentIndex !== 0"
                            >
                                <van-icon name="arrow-left" size="16.3px" />
                            </div>
                            <div
                                class="circle-container right-circle-container"
                                @click="commentSwipeNext"
                                v-show="commentSwipeCurrentIndex !== localCdutcmPortalConfig.commentInfo.length - 1"
                            >
                                <van-icon name="arrow" size="16.3px" />
                            </div>
                        </template>
                    </van-swipe>
                </div>
                <div class="university-info">
                    <span>{{ localCdutcmPortalConfig["universityMessage"] }}</span>
                </div>
            </div>
        </div>
        <TabbarBase />
    </LayoutBase>
</template>

<script>
import Vue from "vue";
import LayoutBase from "@/components/layouts/LayoutBase.vue";
import CommentCard from "@/views/home/tmc/CommentCard.vue";
import PlanCards from "@/views/home/tmc/PlanCards.vue";
import TabbarBase from "@/components/TabbarBase.vue";

export default Vue.extend({
    name: "tcm-home",
    components: { TabbarBase, CommentCard, PlanCards, LayoutBase },
    props: {
        cdutcmPortalConfig: {
            type: Object
        }
    },
    data() {
        return {
            keyWord: "",
            swipeCurrentIndex: 0,
            commentSwipeCurrentIndex: 0
        };
    },
    provide: function() {
        return {
            cdutcmPortalConfig: this.cdutcmPortalConfig[this.localePrefix]
        };
    },
    methods: {
        onSwipeChange(index) {
            this.swipeCurrentIndex = index;
        },
        onCommentSwipeChange(index) {
            this.commentSwipeCurrentIndex = index;
        },
        selectSwipe(n) {
            this.$refs.swipe.swipeTo(n);
        },
        commentSwipePrev() {
            this.$refs.commentSwipe.prev();
        },
        commentSwipeNext() {
            this.$refs.commentSwipe.next();
        }
    },
    computed: {
        localePrefix() {
            return this.$i18n.locale.split("-")[0];
        },
        localCdutcmPortalConfig() {
            return this.cdutcmPortalConfig[this.localePrefix];
        }
    }
});
</script>

<style lang="less" scoped>
.tcm-home {
    .header {
        height: 64px;
        display: flex;
        align-items: center;
        background: #1869b8;
        padding-left: 12px;
        img {
            margin-right: 12px;
            width: 65%;
        }
    }
    .swipe-container {
        .swipe-item {
            img {
                width: 100%;
                height: 440px;
            }
            &.about-us-img,
            &.resources-img {
                background: linear-gradient(215deg, rgba(37, 37, 37, 0) 1.98%, rgba(37, 37, 37, 0.7) 89.97%);
            }
            .welcome-info {
                margin-left: 16px;
                position: absolute;
                margin-top: -192px;
                gap: 16px;
                display: flex;
                flex-direction: column;
                .title {
                    display: flex;
                    align-items: center;
                    font-style: normal;
                    font-size: 24px;
                    font-weight: 900;
                    gap: 10px;
                    .main-title-1 {
                        color: #fff;
                        line-height: 36px;
                    }
                    .main-title-2 {
                        color: #c47a0a;
                        line-height: 31.2px;
                    }
                }
                .new-title {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                }
                .content {
                    color: #fff;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 18px;
                }
            }
            .img-info {
                position: absolute;
                margin-left: 16px;
                margin-right: 16px;
                margin-top: -100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: calc(100% - 164px);
                .title {
                    gap: 11px;
                    color: #fff;
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
                    font-size: 24px;
                    font-style: normal;
                    font-weight: 900;
                    line-height: 36px;
                    display: flex;
                    flex-direction: column;
                    .divider {
                        height: 1px;
                        width: 129px;
                        background: #fff;
                    }
                }
                .content {
                    color: #fff;
                    font-size: 10px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 15px;
                }
            }
        }
        /deep/.custom-indicator {
            position: absolute;
            display: flex;
            flex-direction: row;
            align-items: center;
            width: calc(100% - 32px);
            margin: -80px 16px 16px 16px;
            background-color: #1869b8;
            border-radius: 4px;
            .custom-indicator-item {
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 1 0 0;
                align-self: stretch;
                border-radius: 4px;
                gap: 4px;
                color: #fff;
                font-size: 13px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                padding: 12px 9px;
                &.active {
                    background-color: #c47a0a;
                }
                .custom-indicator-item-img {
                    width: 18px;
                    height: 18px;
                }
            }
        }
    }
    .body {
        position: relative;
        bottom: 20px;
        .welcome-title {
            display: flex;
            padding: 20px 20px 0 20px;
            flex-direction: column;
            align-items: center;
            border-radius: 20px 20px 0 0;
            background: #fff;
            gap: 12px;
            .title {
                font-size: 18px;
                font-style: normal;
                font-weight: 800;
                line-height: 27px;
                .main-title-1 {
                    color: #262833;
                }
                .main-title-2 {
                    color: #c47a0a;
                }
            }
            .search {
                display: flex;
                border-radius: 90px;
                border: 1px solid #1869b8;
                background: #fff;
                width: 100%;
                justify-content: space-between;
                .search-input {
                    width: calc(100% - 52px);
                    padding-left: 16px;
                    border: none;
                    border-radius: 90px;
                }
                .search-button {
                    padding-top: 5px;
                    background-color: #1869b8;
                    border: 1px solid #1869b8;
                    border-radius: 90px;
                    width: 52px;
                    height: 32px;
                }
            }
            .message {
                color: #262833;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
            }
        }
        .about {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            background-color: #1869b8;
            padding-bottom: 150px;
            position: relative;
            .about-title {
                color: #fff;
                font-size: 18px;
                font-style: normal;
                font-weight: 900;
                line-height: 27px;
                margin-bottom: 12px;
                margin-top: 12px;
                padding-left: 20px;
                padding-right: 20px;
            }
            .about-content {
                padding-left: 20px;
                padding-right: 20px;
                color: #fff;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 18px;
                .department-info {
                    &.first {
                        margin-bottom: 8px;
                    }
                }
            }
            .about-image {
                position: absolute;
                display: flex;
                width: 100%;
                bottom: 20px;
                z-index: 1;
                justify-content: center;
                img {
                    height: 110px;
                    width: 165px;
                }
                .first {
                    margin-right: 5px;
                }
            }
            .about-foot {
                height: 105px;
                width: 100%;
                flex-shrink: 0;
                background-color: #c47a0a;
                position: absolute;
                bottom: 0;
                border-radius: 30px 0 0 0;
            }
        }
        .teaching-info {
            width: 100%;
            background: #1869b8;
            padding-bottom: 20px;
            img {
                width: calc(100% - 40px);
                height: auto;
                object-fit: contain;
                margin: 20px 20px 0;
            }
            .info {
                margin: 16px 20px 0;
                .index-number {
                    width: 44px;
                    height: 26px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #c47a0a;
                    color: #fff;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: normal;
                }
                .info-text {
                    color: #fff;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 150%;
                    margin-top: 12px;
                }
            }
        }
        .comment {
            padding: 20px 0;
            background: #fff;
            .title {
                padding: 12px 20px;
                color: #262833;
                font-size: 18px;
                font-style: normal;
                font-weight: 900;
            }
            .comment-list {
                .circle-container {
                    width: 28px;
                    height: 28px;
                    border-radius: 24px;
                    border: 1px solid #f2f2f2;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: -177px;
                    position: absolute;

                    &.left-circle-container {
                        margin-left: 5px;
                    }
                    &.right-circle-container {
                        margin-left: calc(100% - 2.2rem);
                    }
                }
            }
        }
        .university-info {
            background-image: url("../../assets/tcm-portal/tcm-university-info.png");
            background-size: cover;
            height: 210px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 20px;
            span {
                color: #fff;
                font-size: 14px;
                font-style: normal;
                font-weight: 600;
            }
        }
    }
}
</style>
